/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Add {
  /**
   * Sum two numbers
   *
   * @public
   * @function f1.add
   * @param a the first number
   * @param b the second number
   * @example
   *
   * ```ts
   * add(1, 2) === 3
   * ```
   */
  (a: number, b: number): number;
  /**
   * {@link FnAddValue}
   * @param a the first number
   */
  (a: number): (b: number) => number;
}

/**
 * @see Add
 */
export default (a: number, b: number) => a + b;
